// src/components/ui/PaginationWithLimitSelector.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import Pagination from './Pagination';

interface PaginationWithLimitSelectorProps {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
    onPageChange: (page: number) => void;
    onLimitChange: (limit: number) => void;
    className?: string;
    showPageInfo?: boolean;
    limitOptions?: number[];
}

const PaginationWithLimitSelector: React.FC<PaginationWithLimitSelectorProps> = ({
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    onPageChange,
    onLimitChange,
    className = '',
    showPageInfo = true,
    limitOptions = [10, 20, 50]
}) => {
    const { t } = useTranslation();

    return (
        <div className={`flex flex-col lg:flex-row items-center justify-between gap-4 ${className}`}>
            {/* Items per page selector */}
            <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <span>{t('common.pagination.itemsPerPage', 'Items per page')}:</span>
                <select
                    value={itemsPerPage}
                    onChange={(e) => onLimitChange(Number(e.target.value))}
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-transparent"
                >
                    {limitOptions.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>

            {/* Pagination component */}
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={onPageChange}
                showPageInfo={showPageInfo}
            />
        </div>
    );
};

export default PaginationWithLimitSelector;